/** Base url of the (public) blob container which holds the guide PDFs, e.g. https://<account>.blob.core.windows.net/guides */
const GUIDES_URL = process.env.REACT_APP_GUIDES_URL?.replace(/\/+$/, '');

export interface UserGuide {
  /** Translation key of the name of the role the guide is written for */
  labelKey: string;
  url: string;
}

const GUIDE_FILES: { labelKey: string; fileName: string }[] = [
  { labelKey: 'roles.student', fileName: 'student.pdf' },
  { labelKey: 'roles.supervisor', fileName: 'supervisor.pdf' },
  {
    labelKey: 'roles.representativeOrganization',
    fileName: 'organizationrepresentative.pdf',
  },
  { labelKey: 'roles.tutor', fileName: 'tutor.pdf' },
  { labelKey: 'roles.legalDepartment', fileName: 'legaldepartment.pdf' },
  { labelKey: 'roles.rector', fileName: 'rector.pdf' },
  {
    labelKey: 'roles.universityCoordonator',
    fileName: 'university_coordinator.pdf',
  },
];

/** The guides of every role, all of them are shown to every user; empty if the guides url is not configured. */
export const USER_GUIDES: UserGuide[] = GUIDES_URL
  ? GUIDE_FILES.map(({ labelKey, fileName }) => ({
      labelKey,
      url: `${GUIDES_URL}/${fileName}`,
    }))
  : [];
